export const firebaseConfig = {
  apiKey: 'AIzaSyAn1N7BzM4X3sas8EkzMi5ww9nBYLjfnlU',
  authDomain: 'brisbricks.firebaseapp.com',
  databaseURL: 'https://brisbricks.firebaseio.com',
  projectId: 'brisbricks',
  storageBucket: 'brisbricks.appspot.com',
  messagingSenderId: '466934765367',
  appId: '1:466934765367:web:baac335d1aa98f5087acb2',
};
